import React, {useState} from 'react';
import styles from '../css/style.css';
import plugins from '../css/plugins.css';
import {NavLink} from "react-router-dom";
import {
    ABOUT_ROUTE, CATEGORY_BLOCK_HOUSE,
    CATEGORY_EDGED_BOARD, CATEGORY_EVRO_VAGONKA, CATEGORY_FLOOR_BOARD, CATEGORY_IMITATION_TIMBER,
    CATEGORY_PLANED_BLOCK,
    CATEGORY_PLANED_BOARD, CATEGORY_SHTIL, CONTACT,
    INDEX_ROUTE, PHOTO_ROUTE
} from "../utils/consts";

const MenuMobile = () => {
    const [visibleSubMenu, setVisibleSubMenu] = useState(false);
    const [visibleMobileMenu, setVisibleMobileMenu] = useState(false);

    const clickSubMenu = () => {
        setVisibleSubMenu(!visibleSubMenu);
    }

    const openMobileMenu = () => {
        setVisibleMobileMenu(true);
    }

    const closeMobileMenu = () => {
        setVisibleMobileMenu(false);
    }
    return (
        <div className="offcanvas_menu">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="canvas_open">
                            <a href="#" onClick={(e) => {
                                e.preventDefault();
                                openMobileMenu();
                            }}><i className="icon-menu"></i></a>
                        </div>
                        <div className={`offcanvas_menu_wrapper ${visibleMobileMenu && 'active'}`}>
                            <div className="canvas_close">
                                <a href="#" onClick={(e) => {
                                    e.preventDefault();
                                    closeMobileMenu();
                                }}><i className="icon-x"></i></a>
                            </div>
                            <div className="welcome-text">
                                <p><i className="icon-phone"></i>8(916)737-55-95</p>
                                <p><i className="icon-watch"></i>Пн-Пт с 09:00 до 19:00</p>
                            </div>
                            <div id="menu" className="text-left">
                                <ul className="offcanvas_main_menu">
                                    <li className="menu-item-has-children">
                                        <NavLink onClick={() => {closeMobileMenu()}} to={INDEX_ROUTE}>Главная</NavLink>
                                    </li>
                                    <li className="menu-item-has-children">
                                        <span className="menu-expand"><i className={`fa fa-angle-${visibleSubMenu ? 'up' : 'down'}`}></i></span>
                                        <a href="#" onClick={(e) => {
                                            e.preventDefault();
                                            clickSubMenu()
                                        }}>Каталог</a>
                                        <ul className={`sub-menu ${visibleSubMenu && 'visible'}`}>
                                            <li><NavLink onClick={() => {closeMobileMenu()}} to={CATEGORY_PLANED_BOARD}>Доска строганная</NavLink></li>
                                            <li><NavLink onClick={() => {closeMobileMenu()}} to={CATEGORY_PLANED_BLOCK}>Брусок строганный</NavLink></li>
                                            <li><NavLink onClick={() => {closeMobileMenu()}} to={CATEGORY_EDGED_BOARD}>Доска обрезная</NavLink></li>
                                            <li><NavLink onClick={() => {closeMobileMenu()}} to={CATEGORY_BLOCK_HOUSE}>Блок-Хаус</NavLink></li>
                                            <li><NavLink onClick={() => {closeMobileMenu()}} to={CATEGORY_IMITATION_TIMBER}>Имитация бруса</NavLink></li>
                                            <li><NavLink onClick={() => {closeMobileMenu()}} to={CATEGORY_SHTIL}>Штиль</NavLink></li>
                                            <li><NavLink onClick={() => {closeMobileMenu()}} to={CATEGORY_FLOOR_BOARD}>Доска пола</NavLink></li>
                                            <li><NavLink onClick={() => {closeMobileMenu()}} to={CATEGORY_EVRO_VAGONKA}>Евровагонка</NavLink></li>
                                        </ul>
                                    </li>
                                    <li className="menu-item-has-children">
                                        <NavLink onClick={() => {closeMobileMenu()}} to={PHOTO_ROUTE}>Фото</NavLink>
                                    </li>
                                    <li className="menu-item-has-children">
                                        <NavLink onClick={() => {closeMobileMenu()}} to={ABOUT_ROUTE}>О нас</NavLink>
                                    </li>
                                    <li className="menu-item-has-children">
                                        <NavLink onClick={() => {closeMobileMenu()}} to={CONTACT}>Контакты</NavLink>
                                    </li>
                                </ul>
                            </div>

                            <div className="offcanvas_footer">
                                <span><a href="mailto:89852223295@mail.ru"><i className="fa fa-envelope-o"></i>89852223295@mail.ru</a></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MenuMobile;